import { makeDesktopOrMobileComponent } from 'components/Media/makeDesktopOrMobile'

import { DesktopGame } from './Desktop'
import { MobileGame } from './Mobile'

export const Game = makeDesktopOrMobileComponent(DesktopGame, MobileGame)
